module.exports = __webpack_public_path__ + "img/twix.1ca54885.png";